import { useParams } from 'react-router';
import { PayStationPaymentReceiptView } from '../../common/components/ticketplus/PayStationPaymentReceiptView.tsx';
import { useServerFetch } from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import { QuickCheckoutFlowTicketNotFound } from './QuickCheckoutFlowTicketNotFound.tsx';
import { QuickCheckoutFlowTicketExitedForFree } from './QuickCheckoutFlowTicketExitedForFree.tsx';
import { TicketReceipt } from 'dg-web-shared/model/Ticket.ts';
import { isRunningInNativeWrapper } from '../../Native.ts';

interface ReceiptResponse {
    ticketReceipt: TicketReceipt;
    ticketExitedForFree: boolean;
    hasDownloadableReceipt: boolean;
}

export const QuickCheckoutReceiptPunchCardTicket = () => {
    const { ticketBase64 } = useParams();

    const [receiptState] = useServerFetch<
        ReceiptResponse,
        { ticketBase64: string }
    >(
        ({ ticketBase64 }) => ({
            url: `/ui-api/quickcheckout/ticket-receipt/${ticketBase64}`,
        }),
        ticketBase64 ? { ticketBase64 } : null,
    );

    if (receiptState.status === 'error') {
        return <QuickCheckoutFlowTicketNotFound />;
    }

    if (receiptState.status === 'success' && ticketBase64 !== undefined) {
        return (
            <QuickCheckoutReceipt
                ticketReceipt={receiptState.data.ticketReceipt}
                ticketExitedForFree={receiptState.data.ticketExitedForFree}
                hasDownloadableReceipt={
                    receiptState.data.hasDownloadableReceipt
                }
            />
        );
    }

    return null;
};

export const QuickCheckoutReceiptQrTicket = () => {
    const { ticketId } = useParams();

    const [receiptState] = useServerFetch<
        ReceiptResponse,
        { ticketId: string }
    >(
        ({ ticketId }) => ({
            url: `/ui-api/quickcheckout/ticket-receipt-qr/${ticketId}`,
        }),
        ticketId ? { ticketId } : null,
    );

    if (receiptState.status === 'error') {
        return <QuickCheckoutFlowTicketNotFound />;
    }

    if (receiptState.status === 'success' && ticketId !== undefined) {
        return (
            <QuickCheckoutReceipt
                ticketReceipt={receiptState.data.ticketReceipt}
                ticketExitedForFree={receiptState.data.ticketExitedForFree}
                hasDownloadableReceipt={
                    receiptState.data.hasDownloadableReceipt
                }
            />
        );
    }

    return null;
};

export const QuickCheckoutReceipt = ({
    ticketReceipt,
    ticketExitedForFree,
    hasDownloadableReceipt,
}: {
    ticketReceipt: TicketReceipt;
    ticketExitedForFree: boolean;
    hasDownloadableReceipt: boolean;
}) => {
    if (ticketExitedForFree) {
        return <QuickCheckoutFlowTicketExitedForFree />;
    } else {
        return (
            <PayStationPaymentReceiptView
                ticketReceipt={ticketReceipt}
                hasPaidPayment={true}
                hasDownloadableReceipt={hasDownloadableReceipt}
                showTicketPlusUnavailableMessage={isRunningInNativeWrapper()}
            />
        );
    }
};
